import React from 'react';

interface IPrimaryButton {
  label: string;
  disabled?: boolean;
  width?: string;
  icon?: null;
  onClick: () => void;
  height?: string;
  font_size?: string;
}
const PrimaryButtom: React.FC<IPrimaryButton> = ({
  label = '',
  disabled = false,
  icon = null,
  width = 'w-fit',
  onClick = () => {},
  height = 'h-10',
  font_size = 'text-base',
}) => {
  return (
    <div
      className={`flex items-center cursor-pointer rounded-1 text-white px-4 ${height} bg-primary ${
        disabled ? 'opacity-50 pointer-events-none' : ''
      } ${width}`}
      onClick={onClick}
    >
      <label
        className={`text-white ${font_size} mx-auto font-medium whitespace-nowrap cursor-pointer block`}
      >
        {label}
      </label>
    </div>
  );
};

export default PrimaryButtom;
